import {guardarDoc} from "../../Servicios/BD/guardarDoc";

export const crearBolsillo = async ({entidad, usuario}) =>{



    entidad.idUsuario = usuario.id
    entidad.nombresUsuario = usuario.nombres
    entidad.apellidosUsuario = usuario.apellidos
    entidad.celular = usuario.celular
    entidad.correo =usuario.correo
    entidad.cc = usuario.cc

    delete entidad.realizado

    let dox = await guardarDoc('bolsillos', entidad)

    return dox
}